import { render, staticRenderFns } from "./Credits.vue?vue&type=template&id=728c1ac4"
import script from "./Credits.ts?vue&type=script&lang=ts&external"
export * from "./Credits.ts?vue&type=script&lang=ts&external"
import style0 from "./Credits.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports